import { ModuleType, EntityType, ActionType } from "../../queryKeyFactory";

export const reconnectKeyFactory = {
    // Reconnection requests
    list: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "reconnectionRequests",
        "list",
        filters,
    ],
    details: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "reconnectionRequests",
        "details",
        requestId,
    ],
    create: (): [ModuleType, EntityType, ActionType] => [
        "cx",
        "reconnectionRequests",
        "create",
    ],
    update: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "reconnectionRequests",
        "update",
        requestId,
    ],
    delete: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "reconnectionRequests",
        "delete",
        requestId,
    ],
    
    // Summary and statistics
    summary: (params?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "reconnectionRequests",
        "summary",
        params,
    ],
    
    // Plans from onboarding API
    plans: (remoteUtilityId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "reconnectionRequests",
        "plans",
        remoteUtilityId,
    ],
    
    // Consumer operations
    consumerSearch: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "reconnectionRequests",
        "consumerSearch",
        filters,
    ],
    consumerMetaData: (params?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "reconnectionRequests",
        "consumerMetaData",
        params,
    ],
    updateConsumerPlan: (consumerId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "reconnectionRequests",
        "updateConsumerPlan",
        consumerId,
    ],
    reconnectActivateConsumer: (consumerId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "reconnectionRequests",
        "reconnectActivateConsumer",
        consumerId,
    ],
    
    
    // Status operations
    approve: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "reconnectionRequests",
        "approve",
        requestId,
    ],
    reject: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "reconnectionRequests",
        "reject",
        requestId,
    ],
    acknowledge: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "reconnectionRequests",
        "acknowledge",
        requestId,
    ],
    hold: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "reconnectionRequests",
        "hold",
        requestId,
    ],
    resolve: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "reconnectionRequests",
        "resolve",
        requestId,
    ],
    
    // Workflow operations
    workflow: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "reconnectionRequests",
        "workflow",
        requestId,
    ],
    completeWorkflow: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "reconnectionRequests",
        "completeWorkflow",
        requestId,
    ],
    
    // Meter data operations
    meterData: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "reconnectionRequests",
        "meterData",
        requestId,
    ],

    // Utility request configuration
    utilityConfig: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "reconnectionRequests",
        "utilityConfig",
        filters,
    ],
    timeSlotChoices: (): [ModuleType, EntityType, ActionType] => [
        "cx",
        "reconnectionRequests",
        "timeSlotChoices",
    ],
    meterHistory: (consumerId: number): [ModuleType, EntityType, ActionType, number] => [
        "cx",
        "reconnectionRequests",
        "meterHistory",
        consumerId,
    ],
};